import styled from 'styled-components'

export const AppointmentDetailsCard = styled.div`
  position: relative;
  padding: ${({theme}) => theme.spacing.lg};
  border-radius: ${({theme}) => theme.borderRadius.sm};
  box-shadow: ${({theme}) => theme.boxShadow.card};
  background-color: ${({theme}) => theme.colors.white};
  margin-top: ${({theme}) => theme.spacing.md};
`
